app
    .controller('CoachInviteCtrl', function ($http) {
        this.send = () => {
            $http.get(`/coach/invite/${this.resolve.coach.id}`)
                .then(() => this.close());
        };

        this.cancel = () => {
            this.dismiss();
        };

        this.getImage = () => {
            return "/upload/" + this.resolve.coach.picture;
        };
    })
    .component('coachInvite', {
        template: `
        <div class="invite-modal">
        <div class="header">
            <chat-icon width="40" height="40" type="pen"></chat-icon>
            {{ 'modal.inviteCoach.heading' | translate}}
            <div class="right"></div>
        </div>
        <div class="body">
            <img ng-src="{{$ctrl.getImage()}}" alt="">
            <p class="head">
                {{'modal.inviteCoach.line1' | translate : $ctrl.resolve.coach}} <br/>
                {{'modal.inviteCoach.line2' | translate}} <br/>
                {{'modal.inviteCoach.line3' | translate}}
            </p>
            <p>
                {{ 'modal.inviteCoach.line4' | translate }} <br/>
                {{ 'modal.inviteCoach.line5' | translate }}
            </p>
            <button class="btn btn-invite" ng-click="$ctrl.send()">
                {{ 'modal.inviteCoach.button.confirm' | translate}}
            </button>
            <button class="btn btn-light" ng-click="$ctrl.cancel()">
                {{'modal.inviteCoach.button.cancel' | translate}}
            </button>
        </div>
</div>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'CoachInviteCtrl'
    });
